export default {
  downloadColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  },
  downloadLink: {
    display: 'flex',
    columnGap: '4px',
    alignItems: 'center',
    span: {
      textDecoration: 'underline'
    }
  }
};